import React, { Component } from 'react';
import { map } from 'lodash';

function breakFirstWord(str) {
  if (!str) return null;
  const [word, ...rest] = str.split(' ');

  return (
    <React.Fragment>
      <span className="product-sizing-table__name">{word}</span><br />
      <span className="product-sizing-table__subline">{rest.join(' ')}</span>
    </React.Fragment>
  )
}

const SizingTable = ({ sizeGuide }) => (
  <div className="product-sizing-table">
    <h2>Size Guide</h2>

    <table>
      <tbody>
      {map(sizeGuide.data, (row, i) => (
        <tr key={i}>
          {map(row, (col, j) => (
            <td key={`${i}-${j}`}>
              {j === 0
               ? breakFirstWord(col)
               : col}
            </td>
          ))}
        </tr>
      ))}
      </tbody>
    </table>
  </div>
);

export default SizingTable;



// WEBPACK FOOTER //
// ./assets/scripts/components/Product/SizingTable.js